import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { CIRCUIT_PATH } from '../../../../config/paths';
import CircuitDeleteButton from './CircuitDeleteButton';
import CircuitActiveButton from './CircuitActiveButton';
import CloneCircuitButton from './CloneCircuitButton';

const CircuitToolbar = ({ circuitId, active }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <CircuitActiveButton circuitId={circuitId} active={active}/> {' '}
      <EditButton path={`${CIRCUIT_PATH}/${circuitId}/edit`} />{' '}
      <CloneCircuitButton circuitId={circuitId} />{' '}
      <CircuitDeleteButton circuitId={circuitId} />
    </div>
  </ButtonToolbar>
);

CircuitToolbar.propTypes = {
  circuitId: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
};

export default CircuitToolbar;
